import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-animate-spin-button',
    templateUrl: './animate-spin-button.component.html',
})
export class AnimateSpinButtonComponent {
    @Input() textDisplay = 'text.processing';
    @Input() buttonCssClass = 'btn-disabled';
}
